import LinkPost from "../../../../src/components/linkPost";
import ImgPost from "../../../../src/components/imgPost";
import Post from "../../../../contents/posts/51-validate-commit-message-using-commitlint-husky/1-post.png";
import * as React from 'react';
export default {
  LinkPost,
  ImgPost,
  Post,
  React
};